// src/hooks/useOrderValidation.js
import { useMemo } from 'react';

export const useOrderValidation = () => {
  return useMemo(() => ({
    customer: (data) => {
      const customer = data.customer;
      return !!(
        customer &&
        customer.companyName &&
        customer.companyName.trim().length > 0 &&
        (customer.isSelected || customer.isNewCustomer)
      );
    },

    products: (data) => {
      if (!data.orderItems || data.orderItems.length === 0) {
        return false;
      }
      
      return data.orderItems.every(item => {
        const hasQuantity = (item.quantita > 0 || item.quantity > 0);
        const hasPrice = (item.prezzo > 0 || item.unitPrice > 0);
        const hasProduct = (item.product || item.codice);
        
        return hasQuantity && hasPrice && hasProduct;
      });
    },

    payment: (data) => {
      return !!(
        data.paymentMethod &&
        ['contrassegno', 'consegna', 'anticipato'].includes(data.paymentMethod)
      );
    },

    final: (data) => {
      return !!(
        data.customer &&
        data.customer.companyName &&
        data.orderItems &&
        data.orderItems.length > 0 &&
        data.paymentMethod
      );
    }
  }), []);
};